<script setup>
import { computed } from 'vue';
import { useMapGetter, useStore } from 'dashboard/composables/store';

const props = defineProps({
  conversationId: {
    type: [Number, String],
    required: true,
  },
});

const store = useStore();
const currentChat = useMapGetter('getSelectedChat');
const contactGetter = useMapGetter('contacts/getContact');
const contactId = computed(() => currentChat.value?.meta?.sender?.id);
const contact = computed(() => contactGetter.value(contactId.value));

const iframeSrc = computed(() => {
  const inboxId = currentChat.value?.inbox_id || '';
  const phone = contact.value?.phone_number || '';
  const name = contact.value?.name || '';
  const email = contact.value?.email || '';
  const params = new URLSearchParams({
    inbox_id: inboxId,
    phone: phone,
    name: name,
    email: email,
  });
  return '/wc-dashboard/index.html?_v=2&' + params.toString();
});
</script>

<template>
  <div class="wc-dashboard-wrap">
    <iframe
      :src="iframeSrc"
      class="wc-dashboard-frame"
    />
  </div>
</template>

<style scoped>
.wc-dashboard-wrap {
  width: 100%;
}
.wc-dashboard-frame {
  width: 100%;
  height: 70vh;
  border: 0;
}
</style>
